import React from 'react'

import { DropdownButton } from './DropdownButton'
import { ProductsSyncButtons, SyncMessages } from './ProductsSyncButtons'

import { useLogic } from '../hooks/storeHook'
import { useHomeHasStoreType } from '../hooks/myProductHooks'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { observer } from 'mobx-react-lite'

export const EditProductsButton =
  observer(
  () => {
    const logic = useLogic()
    const homeHasStoreType = useHomeHasStoreType()

    return (
      <DropdownButton text="Изменить" loadingText="Изменяем..." popupWidth={300}>
        {
          buttonProps => <>
            {
              homeHasStoreType(IntegrationType.Ozon) &&
              <ProductsSyncButtons
                messages={messages.ozon}
                toggleSync={logic.ozonSyncSelectedProducts}
                {...buttonProps}
              />
            }

            {
              homeHasStoreType(IntegrationType.Wildberries) &&
              <ProductsSyncButtons
                messages={messages.wb}
                toggleSync={logic.wbSyncSelectedProducts}
                {...buttonProps}
              />
            }

            {
              homeHasStoreType(IntegrationType.YandexMarket) &&
              <ProductsSyncButtons
                messages={messages.yandexMarket}
                toggleSync={logic.yandexMarketSyncSelectedProducts}
                {...buttonProps}
              />
            }
          </>
        }
      </DropdownButton>
    )
  })

const makeMessages =
  (name: string): SyncMessages => ({
    on: `Включить передачу остатков ${name}`,
    off: `Отключить передачу остатков ${name}`,

    onSuccess: 'Включено',
    offSuccess: 'Отключено',

    onError: `Не удалось включить передачу остатков ${name}`,
    offError: `Не удалось отключить передачу остатков ${name}`
  })

const messages = {
  ozon: makeMessages('Ozon'),
  wb: makeMessages('Wildberries'),
  yandexMarket: makeMessages('Yandex.Market')
}